import { mhvUrl } from '@department-of-veterans-affairs/platform-site-wide/mhv/utilities';

export default [
  {
    href: mhvUrl(true, 'home'),
    title: 'My HealtheVet',
  },
];
